
/*
*
* File JS Atomo Video
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './index.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const video = () => {

    // Trova tutti i controlli custom dei video sulla pagina
    const allControls = document.querySelectorAll('.video-custom-controls');

    if (allControls.length === 0) {
        return;
    }
    
    allControls.forEach(controls => {
        const videoId = controls.dataset.controlsFor;
        const video = document.getElementById(videoId);

        if (video) {
            const playBtn = controls.querySelector('.play-btn');
            const pauseBtn = controls.querySelector('.pause-btn');
            const loopBtn = controls.querySelector('.loop-btn');
            const muteBtn = controls.querySelector('.mute-btn');
            const unmuteBtn = controls.querySelector('.unmute-btn');
            const fullscreenBtn = controls.querySelector('.fullscreen-btn');
            
            // Funzione per aggiornare la visibilità dei bottoni play/pausa
            const updatePlayPauseButtons = () => {
                if (video.paused) {
                    if (playBtn) playBtn.style.display = 'flex';
                    if (pauseBtn) pauseBtn.style.display = 'none';
                } else {
                    if (playBtn) playBtn.style.display = 'none';
                    if (pauseBtn) pauseBtn.style.display = 'flex';
                }
            };

            // Funzione per aggiornare la visibilità dei bottoni mute/unmute
            const updateMuteButtons = () => {
                if (video.muted) {
                    if (muteBtn) muteBtn.style.display = 'none';
                    if (unmuteBtn) unmuteBtn.style.display = 'flex';
                } else {
                    if (muteBtn) muteBtn.style.display = 'flex';
                    if (unmuteBtn) unmuteBtn.style.display = 'none';
                }
            };

            // Eventi per aggiornare lo stato
            video.addEventListener('play', updatePlayPauseButtons);
            video.addEventListener('pause', updatePlayPauseButtons);
            video.addEventListener('volumechange', updateMuteButtons);

            // Click listeners - ORA PROTETTI!
            if (playBtn) {
                playBtn.addEventListener('click', () => {
                    video.play();
                });
            }

            if (pauseBtn) {
                pauseBtn.addEventListener('click', () => {
                    video.pause();
                });
            }

            if (loopBtn) {
                loopBtn.addEventListener('click', () => {
                    video.loop = !video.loop;
                    loopBtn.classList.toggle('active', video.loop);
                });
            }

            if (muteBtn) {
                muteBtn.addEventListener('click', () => {
                    video.muted = true;
                });
            }

            if (unmuteBtn) {
                unmuteBtn.addEventListener('click', () => {
                    video.muted = false;
                });
            }

            if (fullscreenBtn) {
                fullscreenBtn.addEventListener('click', () => {
                    if (video.requestFullscreen) {
                        video.requestFullscreen();
                    } else if (video.webkitRequestFullscreen) {
                        video.webkitRequestFullscreen();
                    } else if (video.msRequestFullscreen) {
                        video.msRequestFullscreen();
                    }
                });
            }

            // Stato iniziale
            updatePlayPauseButtons();
            updateMuteButtons();
        }
    });
}


var _default = video;

if (typeof window !== 'undefined' && typeof _default !== 'undefined') {
  window.__imComponents = window.__imComponents || {};
  window.__imComponents["_video"] = _default;
}

export default video;

//--------------------------------------------------------------------//